import { DraftConfiguration, DraftState } from '@/types';
import { removeConfiguration } from './helper/removeConfiguration';

export const removeConfigurationAction =
  (configurations: DraftConfiguration | DraftConfiguration[]) => (draft: DraftState) => {
    (Array.isArray(configurations) ? configurations : [configurations]).forEach(({ cid }) =>
      removeConfiguration(draft, cid)
    );
  };
